import React, { useEffect } from "react";
import { Table, Tooltip, Image } from "antd";
import { ColumnsType } from "antd/es/table";
import { useCardcaseModel } from "../cardcaseModel";
import { ICardcaseDetail } from "../cardcaseService";
import { getBaseRequestUrl, getToken, getFileUrl } from "@/utils/constants";
import { useDictModel } from "@/views/base/dict/dictModel";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, loadDataGroup
    } = useCardcaseModel();
    const { getTreeNodeName } = useDictModel(() => []);

    useEffect(() => {
        loadData();
        loadDataGroup()
    }, [])

    const columns: ColumnsType<ICardcaseDetail> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '用户姓名',
            width: 120,
            dataIndex: 'name',
            fixed: "left",
        }, {
            title: '头像',
            width: 80,
            dataIndex: 'icon',
            className: "p-0",
            render: icon => icon ? <Image src={getFileUrl(icon)} style={{ width: "40px", height: "40px", marginRight: "10px" }} /> : ""
        }, {
            title: '识别图片',
            width: 80,
            dataIndex: 'md5',
            className: "p-0",
            render: md5 => md5 ? <Image src={getFileUrl(md5)} style={{ width: "40px", height: "40px", marginRight: "10px" }} /> : ""
        }, {
            title: '电话',
            width: 120,
            dataIndex: 'phone',
        }, {
            title: '分组',
            width: 120,
            dataIndex: 'typeName',
        }, {
            title: '邮箱',
            width: 140,
            dataIndex: 'email',
        }, {
            title: '网址',
            width: 120,
        }, {
            title: '地址',
            width: 180,
            dataIndex: 'address',
            render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '公司',
            width: 180,
            dataIndex: 'company',
            render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '部门',
            width: 140,
            dataIndex: 'depName',
        }, {
            title: '职位',
            width: 120,
            dataIndex: 'position',
        }, {
            title: '微信号',
            width: 100,
            dataIndex: 'wechat',
        }, {
            title: '名片属性',
            width: 160,
            dataIndex: 'cardType',
            render: text => getTreeNodeName(text),
        }, {
            title: '创建时间',
            width: 180,
            dataIndex: 'createTime',
        }
    ];


    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            rowKey={record => record.id ?? ""}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id);
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId] as string[])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id ?? ""),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id ?? ""),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id ?? ""]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}